import { parseBlocks, type Inline } from "./miniMarkdown";
import css from "./AssistantPanel.module.css";

function Inlines({ parts }: { parts: Inline[] }) {
  return (
    <>
      {parts.map((p, i) =>
        p.kind === "bold" ? <strong key={i}>{p.text}</strong>
        : p.kind === "code" ? <code key={i} className={css.code}>{p.text}</code>
        : <span key={i}>{p.text}</span>)}
    </>
  );
}

export function MiniMarkdown({ text }: { text: string }) {
  const blocks = parseBlocks(text);
  return (
    <>
      {blocks.map((b, i) => {
        if (b.kind === "p") return <p key={i} className={css.p}><Inlines parts={b.inlines} /></p>;
        if (b.kind === "ul") return (
          <ul key={i} className={css.ul}>{b.items.map((it, j) => <li key={j}><Inlines parts={it} /></li>)}</ul>
        );
        return (
          <div key={i} className={css.tableWrap}>
            <table className={css.table}>
              <thead><tr>{b.header.map((c, j) => <th key={j}><Inlines parts={c} /></th>)}</tr></thead>
              <tbody>{b.rows.map((r, j) => <tr key={j}>{r.map((c, k) => <td key={k}><Inlines parts={c} /></td>)}</tr>)}</tbody>
            </table>
          </div>
        );
      })}
    </>
  );
}
